import React from 'react';
import PropTypes from 'prop-types';
import SubmitButton from '../SubmitButton';
import Icon from '../../../../../assets/images/pro/pay_with_paypal@2x.png';
import * as styles from '../styles/styles.module.scss';

const PayWithPayPalButton = ({ text, handler, disabled }) => {
  const content = (
    <span className={styles.contents}>
      {text}
      <img className={styles.payPalIcon} src={Icon} />
    </span>
  );

  return <SubmitButton text={content} handler={handler} disabled={disabled} variant="payPalCheckout" />;
};

PayWithPayPalButton.propTypes = {
  text: PropTypes.element.isRequired,
  handler: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default PayWithPayPalButton;
